import { SimulatorService } from './../services/simulator.service';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Simulator } from '../models/simulators';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SimulatorCreateModalComponent } from '../modals/simulator/simulator-create-modal/simulator-create-modal.component';
import { SimulatorQueryFilter } from './simulator-list-query-filter';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { SimulatorEditModalComponent } from '../modals/simulator/simulator-edit-modal/simulator-edit-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { MessageModalComponent } from 'src/app/shared/modals/message-modal/message-modal.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'simulators',
    templateUrl: './simulators-list.component.html',
    styleUrl: './simulators-list.component.scss',
    standalone: false
})
export class SimulatorsListComponent extends BaseComponent implements OnInit{
  @Input() filter: SimulatorQueryFilter = new SimulatorQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public simulators: Simulator[] = [];

  constructor(sessionService: SessionService,
    private simulatorService: SimulatorService,
    private dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['bayNumber', 'bayName', 'capacity', 'isAvailable', 'lastEditedDate', 'actions'];
  }

  ngOnInit(): void {
    this.getSimulators();
  }

  getSimulators(){
    this.isLoading = true;
    this.filter.organizationId = this.sessionService.getUser().organizationId;
    this.simulatorService.getAllByOrganization(this.filter).subscribe({
      next: (result) => {
        this.simulators = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getSimulators();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }

  createSimulator(){
    const dialogRef = this.dialog.open(SimulatorCreateModalComponent);

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getSimulators();
      }
    });
  }

  updateIsAvailable(simulator: Simulator, event: MatSlideToggleChange){
    this.isLoading = true;

    if(this.simulators.filter(s => s.isAvailable === true).length >= this.sessionService.getUser().permissions.simulatorCount){
      this.isLoading = false;
      this.alertModal('Cannot Update Simulator', 'You cannot update the availability of a simulator because you have no simulators left on your subscription. Please upgrade your subscription to add more simulators.', 'OK', null, false, null);
      event.source.checked = false;
      return;
    }

    simulator.isAvailable = event.checked;
    simulator.lastEditedBy = this.sessionService.getUserId();

    this.simulatorService.update(simulator.id, simulator).subscribe({
      next: () => {
        this.getSimulators();
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  edit(simulator: Simulator){
    const dialogRef = this.dialog.open(SimulatorEditModalComponent, {
      height: 'auto',
      width: '500px',
    });

    dialogRef.componentInstance.simulator = simulator;

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getSimulators();
      }
    });
  }

  delete(simulator: Simulator){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Simulator';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Simulator ${simulator.bayNumber} <strong>(${simulator.bayName})</strong>? <br />You will no longer be able to access any of the previous bookings for this simulator.</h2>`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        let data = {id: simulator.id, lastEditedBy: this.getUserIdFromSession()};
        this.simulatorService.delete(data).subscribe(() => {
          this.getSimulators();
          this.isLoading = false;
        }, err =>{
          this.isLoading = false;
          //throw error
        });
      }
    });
  }

  alertModal(title: string, body: string, okayButtonText: string, otherButtonText: string, isOtherButtonVisible: boolean, callback: () => void) {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      height: 'auto',
      width: 'auto'
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.body = body;
    dialogRef.componentInstance.okayButtonText = okayButtonText;
    dialogRef.componentInstance.otherButtonText = otherButtonText;
    dialogRef.componentInstance.isOtherButtonVisible = isOtherButtonVisible;
  }
}
